export class SearchModel{
    fromDate?:Date;
    toDate?:Date;

    countryId?:number;


    constructor(item?:SearchModel){
        item = item? item:{};
        this.fromDate = item.fromDate? item.fromDate:new Date();
        this.toDate = item.toDate? item.toDate:new Date();
        this.countryId = item.countryId? item.countryId:0;
      
        
    
    }

}